// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type CareerHubTopicTitlesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CareerHubTopicTitlesQuery = {
  __typename?: 'Query';
  careerHubTopics?: {
    __typename?: 'CareerHubTopicsResponse';
    collection: Array<{
      __typename?: 'CareerHubTopic';
      title: string;
      key: string;
    } | null>;
  } | null;
};

export const CareerHubTopicTitlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'careerHubTopicTitles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careerHubTopics' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CareerHubTopicTitlesQuery,
  CareerHubTopicTitlesQueryVariables
>;
